<template>
	<div :style="shu.yangshi">
		<!-- 三列 -->
		<div v-if="shu.pailiefangshi==3" class="zidingyi_Shangpin">
			<div class="zidingyi_Shangpin_box" v-for="(l,i) in shu.shu" :key='i'>
				<el-image class="zidingyi_Shangpin_image" :src="l.tu" fit="fill"></el-image>
				<div class="zidingyi_Shangpin_ming">{{l.ming}}</div>
				<div class="zidingyi_Shangpin_jiage">
					￥{{l.jiage}}
					<span class="iconfont icongouwu2" v-if="shu.ico==1"></span>
				</div>
			</div>
		</div>
		<!-- 两列 -->
		<div v-else-if="shu.pailiefangshi==2" class="zidingyi_Shangpin">
			<div class="zidingyi_Shangpin2_box" v-for="(l,a) in shu.shu" :key="a">
				<el-image class="zidingyi_Shangpin2_image" :src="l.tu" fit="fill"></el-image>
				<div class="zidingyi_Shangpin_ming">{{l.ming}}</div>
				<div class="zidingyi_Shangpin_jiage">￥{{l.jiage}}</div>
			</div>
		</div>
		<!-- 一列 -->
		<div v-else class="zidingyi_Shangpin">
			<div class="zidingyi_Shangpin3_box" v-for="(l,ii) in shu.shu" :key="ii">
				<el-image class="zidingyi_Shangpin3_image" :src="l.tu" fit="fill"></el-image>
				<div class="zidingyi_Shangpin3_right">
					<div class="zidingyi_Shangpin_ming">{{l.ming}}</div>
					<div class="zidingyi_Shangpin3_jiage">
						<span>
							<span style="font-size: 24upx;color: #FD0539;">￥</span>
							{{l.jiage}}
						</span>
						<span class="zidingyi_Shangpin_yuanjia">400</span>
						<span class="duihuanganniu">去兑换</span>
					</div>
				</div>
				<!-- <el-image class="zidingyi_Shangpin3_image"></el-image>
				<div class="zidingyi_Shangpin_ming">{{l.name}}</div>
        <div class="zidingyi_Shangpin_jiage">￥{{l.jiage}}</div>-->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Shangpin",
		data() {
			return {			
			};
		},
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: "输入文字",
						yangshi: {}
					};
				}
			}
		},

		created() {
			this.CSH();			
		},
		methods: {
			CSH(){
				var that=this;
				if(!this.shu.shu){
					var shu={ye:1,jitiao:6};	
					this.shu.mokuai="zw_shangcheng";	
					this.shu.pailiefangshi='2';		
					this.shu.guding='1';						
					this.$post("m="+this.shu.mokuai+'&k=shangpin',shu,function(s) {
						if (s.shi == 1) {	
							that.$set(that.shu, "shu",s.shu.lie);									
						}
					});
				}				
			},
		}
	}
</script>
